const template=`
<!-- Expecations:-->
<!--    The following variables are available on the scope:-->
<!--    - widgetIsLoading: do we have data, or should we be showing the ...-->
<!--    - dataUnavailable: Was there some sort of error loading the data?-->
<!--    - noDataFromServer: No data from server.. automatic? Why is this separate from dataUnavailable?-->
<!--    - notConfigured: Automatic? Widget isn't configured-->
<!--    - hidePercentageMode: true to hide percentage mode; (implied) false otherwise.-->
<!--    - toggleGraph: A method to change the current chart type.-->
<!--    - toggleDrilldown: A method to change the current percentage mode-->
<div class="widgetDetails">
  <div class="widgetContentMax insWidgetMax" ng-class="'max-' + widget.directive">
    <widget-status></widget-status>
    <generic-highchart
      chart-data="chartData"
      height="231"
      switcher="drillDown()"
      ng-hide="widgetIsLoading || serviceError || noDataFromServer || notConfigured || showTable"
      ng-if="!showMwVizBarChart && !mwVizBarChartFeature"
    >
    </generic-highchart>
    <mw-chart-one-series-bar
      chart-data="mwOneSeriesBarChartData"
      chart-options="mwOneSeriesBarChartOptions"
      get-api="getMwApi(API)"
      ng-hide="widgetIsLoading"
      ng-if="showMwVizBarChart && mwVizBarChartFeature"
      style="width:700px; height:400px;"
    >
    </mw-chart-one-series-bar>
    <chart-data-table
      display-field="tableSettings.displayField"
      drilldown="tableSettings.drilldown"
      ng-if="showTable && !widgetIsLoading"
      row-title="tableSettings.rowTitle"
      table-data="tableSettings.data"
      title-field="tableSettings.titleField"
      tooltip="tableSettings.tooltip"
      summary="tableSettings.summary"
      summary-title="tableSettings.summaryTitle"
    >
    </chart-data-table>
  </div>
</div>`;
export default template;
